import toast from 'react-hot-toast';
import type { UploadedVoiceMessage } from '../../api/payment/donate-voice.api';
import type { VoiceRecorderValue } from './voice-recorder';

// Lược đồ dùng chung cho cả khung donate trang cá nhân và donate bài viết: có ghi âm thì
// tải lên media-service TRƯỚC để lấy voiceClipId rồi mới donate; tải lỗi thì dừng lại, báo lỗi,
// KHÔNG donate (tránh trừ Ca mà không kèm được lời nhắn). `donate` là lời gọi donate riêng của
// từng khung (đã tự xử lý success/error/finally của nó) — hàm này chỉ quyết định donate() có
// được gọi hay không và gọi với voiceClipId nào. `uploader` do bên gọi truyền vào (thường là
// `uploadVoiceMessage` thật) — chỉ dùng type-only import ở đây để hàm này không kéo theo axios,
// giữ module thuần và test được không cần mock mạng.
export type VoiceUploader = (blob: Blob, mime: string) => Promise<UploadedVoiceMessage>;

export const submitWithVoice = async <T>(
  voiceClip: VoiceRecorderValue | null,
  donate: (voiceClipId?: string) => Promise<T>,
  uploader: VoiceUploader
): Promise<T> => {
  if (!voiceClip) {
    return donate();
  }

  let uploaded: UploadedVoiceMessage;
  try {
    uploaded = await uploader(voiceClip.blob, voiceClip.mime);
  } catch (err: any) {
    toast.error(err?.response?.data?.message ?? 'Không tải được ghi âm, vui lòng thử lại.');
    throw err;
  }

  return donate(uploaded.id);
};
